import { render, staticRenderFns } from "./SpecificChallenge.vue?vue&type=template&id=9fbe55d4&scoped=true&"
import script from "./SpecificChallenge.vue?vue&type=script&lang=js&"
export * from "./SpecificChallenge.vue?vue&type=script&lang=js&"
import style0 from "./SpecificChallenge.vue?vue&type=style&index=0&id=9fbe55d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fbe55d4",
  null
  
)

export default component.exports